import { FETCH_ADDRESS_LIST_START, FETCH_ADDRESS_LIST_SUCCESS, FETCH_ADDRESS_LIST_FAIL } from "./actions";

const initialState = {
  addresses: [],
  isFetching: false,
  hasError: false,
};

export default function addresses(state = initialState, action) {
  switch (action.type) {
    case FETCH_ADDRESS_LIST_START:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        addresses: action.payload,
        isFetching: false,
        hasError: false,
      };

    case FETCH_ADDRESS_LIST_FAIL:
      return {
        ...state,
        isFetching: false,
        hasError: true,
      };

    default:
      return state;
  }
}

export * from "./actions";
export * from "./selectors";
